export default class AssetHistoryViewModel {
    id = null;
    assetId = null;
    numberOfMarkers = null;
    integrityScore = null;
    createdOn = null;

    constructor(response){
        this.id = response.id;
        this.assetId = response.assetId;
        this.numberOfMarkers = response.numberOfMarkers;
        this.integrityScore = response.integrityScore;
        this.createdOn = response.createdOn;
    }
}